import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  SelectChangeEvent,
} from "@mui/material";
import { countries, states } from "../../../utils/staticValues";

interface AddressInputFormProps {
  values: Record<string, string>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement> | unknown) => void;
  errors: Record<string, string>;
  touched: Record<string, boolean>;
  textFieldStyles: Record<string, any>;
  businessInfo?: Record<string, string | number | boolean | any>;
}

const AddressInputForm: React.FC<AddressInputFormProps> = ({
  values,
  handleChange,
  errors,
  touched,
  textFieldStyles,
  businessInfo,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="First Name"
          name="firstName"
          value={values.firstName}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.firstName && !!errors.firstName}
          helperText={touched.firstName && errors.firstName}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Last Name"
          name="lastName"
          value={values.lastName}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.lastName && !!errors.lastName}
          helperText={touched.lastName && errors.lastName}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Phone Number"
          name="phoneNumber"
          value={values.phoneNumber}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.phoneNumber && !!errors.phoneNumber}
          helperText={touched.phoneNumber && errors.phoneNumber}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Email"
          name="email"
          value={values.email}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.email && !!errors.email}
          helperText={touched.email && errors.email}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Address 1"
          name="address1"
          value={values.address1}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.address1 && !!errors.address1}
          helperText={touched.address1 && errors.address1}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Address 2"
          name="address2"
          value={values.address2}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="City"
          name="city"
          value={values.city}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.city && !!errors.city}
          helperText={touched.city && errors.city}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>State</InputLabel>
          <Select
            name="state"
            value={values.state}
            onChange={handleChange}
            error={touched.state && !!errors.state}
          >
            {states.map((state) => (
              <MenuItem
                key={state.code}
                value={state.code}
                sx={{ color: "#FFFFFF" }}
              >
                {state.name}
              </MenuItem>
            ))}
          </Select>
          {touched.state && errors.state && (
            <p style={{ color: "red", fontSize: "0.8rem" }}>{errors.state}</p>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Zip Code"
          name="zipcode"
          value={values.zipcode}
          onChange={handleChange}
          fullWidth
          sx={textFieldStyles}
          error={touched.zipcode && !!errors.zipcode}
          helperText={touched.zipcode && errors.zipcode}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>Country</InputLabel>
          <Select
            name="country"
            value={values.country}
            onChange={handleChange}
            error={touched.country && !!errors.country}
          >
            {countries.map((country) => (
              <MenuItem
                key={country.code}
                value={country.code}
                sx={{ color: "#FFFFFF" }}
              >
                {country.name}
              </MenuItem>
            ))}
          </Select>
          {touched.country && errors.country && (
            <p style={{ color: "red", fontSize: "0.8rem" }}>{errors.country}</p>
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AddressInputForm;
